/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

// import { USER_LISTING_PREFERENCES_QUERY } from '@/graphql/listing/user_preferences/queries';
import {
  SAVE_USER_LISTING_PREFERENCES_MUTATION,
  DELETE_USER_LISTING_PREFERENCES_MUTATION,
} from '@/graphql/listing/user_preferences/mutations';

export async function saveUserListingPreferences(apollo, variables) {
  let result;
  let error;

  try {
    result = await apollo.mutate({
      mutation: SAVE_USER_LISTING_PREFERENCES_MUTATION,
      variables,
      // TODO: consider using apollo cache and optimisticResponse
      // update: (cache, { data: createdPreference }) => {
      // TODO: TEMP
      //   if (data.data.saveUserListingPreferences.result) {
      //     console.log('Saving user preferences successful');
      //     console.log('User preferences saved: ', JSON.stringify(userPreferences, null, 2));
      //   }

      //   const query = {
      //     query: USER_LISTING_PREFERENCES_QUERY,
      //     variables: { state: variables.state },
      //   };

      //   const data = cache.readQuery(query);
      //   // TODO: chance cache data
      //   cache.writeQuery({
      //     ...query,
      //     data,
      //   });
      // },
    });
  } catch (err) {
    error = err;
  }

  return { result, error };
}

export async function deleteUserListingPreferences(apollo, variables) {
  let result;
  let error;

  try {
    result = apollo.mutate({
      mutation: DELETE_USER_LISTING_PREFERENCES_MUTATION,
      variables,
      // TODO: consider using apollo cache and optimisticResponse
      // update: (cache, { data: deletedPreference }) => {
      // TODO: TEMP
      //   if (data.data.deleteUserListingPreferences.result) {
      //     console.log('Deleting user preferences successful');
      //     console.log('Prefs deleted: ', JSON.stringify(userPreferencesToDelete, null, 2));
      //   }

      //   const query = {
      //     query: USER_LISTING_PREFERENCES_QUERY,
      //     variables: { state: variables.state },
      //   };

      //   const data = cache.readQuery(query);
      //   // TODO: chance cache data
      //   cache.writeQuery({
      //     ...query,
      //     data,
      //   });
      // },
    });
  } catch (err) {
    error = err;
  }

  return { result, error };
}
